// JsFromRoutes CacheKey c278d437ee13bb649d91a85bef65d384
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/axios'

export default {
  activeUsers: definePathHelper('get', '/admin/users/active_users'),
}
